import { DialogActions, DialogContent } from '@mui/material';
import TextFieldLimited from 'Components/Forms/TextFieldLimited';
import createRawMaterialSchema from 'FeatureModules/ComponentChain/schemas/rawMaterials.schemas';
import { DialogDefault, FieldWrapper, ThemeButton } from 'DesignSystem';
import { Field, Form, Formik } from 'formik';
import React, { FC } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import useRawMaterials from '../../hooks/useRawMaterials';

const AddRawMaterialDialog: FC<IDefaultDialogProps> = ({ open, onClose }) => {
  const { createRawMaterial } = useRawMaterials();

  const handleCreateRawMaterial = (values: { title: string }) => {
    createRawMaterial({ variables: { input: { title: values.title } } });
  };

  return (
    <DialogDefault
      open={open}
      title="Add raw material"
      fullWidth
      data-testid="add-raw-material-dialog"
      onClose={onClose}
    >
      <Formik
        initialValues={{ title: '' }}
        validationSchema={createRawMaterialSchema}
        onSubmit={handleCreateRawMaterial}
      >
        {({ isValid }) => (
          <Form data-testid="create-raw-material-form">
            <DialogContent>
              <FieldWrapper label="Add the new raw material" variant="small">
                <Field
                  name="title"
                  fullWidth
                  placeholder="E.g. Tomato, Onion, Cow milk"
                  component={TextFieldLimited}
                  variant="outlined"
                  charLimit={50}
                  inputProps={{
                    'data-testId': 'field-component-title',
                  }}
                />
              </FieldWrapper>
            </DialogContent>
            <DialogActions>
              <ThemeButton
                color="WHITE"
                size="large"
                data-testid="add-raw-material-dialog-cancel"
                onClick={onClose}
              >
                Cancel
              </ThemeButton>
              <ThemeButton
                type="submit"
                size="large"
                disabled={!isValid}
                data-testid="add-raw-material-dialog-copy"
              >
                Add
              </ThemeButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </DialogDefault>
  );
};

export default AddRawMaterialDialog;
